module.exports = __webpack_public_path__ + "img/CIMG0198.d65e4332.jpg";